import { createAction, props } from '@ngrx/store';
import { Slider } from '../../models';

export const LoadSlider = createAction('[Slider] Load Slider', props<{ id: number }>());
export const LoadSliderSuccess = createAction('[Slider] Load Slider Success', props<{ slider: Slider }>());
export const LoadSliderFail = createAction('[Slider] Load Slider Fail', props<{ error: any }>());
